'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var L = exports.L = 'L';
var M = exports.M = 'M';
var Q = exports.Q = 'Q';
var H = exports.H = 'H';


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-qr-code/lib/constants/levels.js
// module id = 969
// module chunks = 0